import { useMutation, useQueryClient } from '@tanstack/react-query';
import { triggerRun } from '../services/operationsReportsApi';
import { useAuthStore } from '../store/authStore';

// Mutation hook for the manual retry affordance on failed report rows (#359).
// On success, invalidates the runs infinite-query so the failed row is replaced
// by the freshly generated succeeded one. The backend trigger endpoint is
// synchronous (waits for generation to complete), so isPending stays true for
// the full ~30-60s the report takes.
export function useDailyOpsRunRetry() {
  const queryClient = useQueryClient();
  const userId = useAuthStore((s) => s.user?.user_id);

  return useMutation({
    mutationFn: (siteId: string) => triggerRun(siteId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['operations-reports', 'runs', userId] });
    },
  });
}
